"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEmail = exports.serializeEmail = void 0;
const validateEmailString = (email) => {
    return String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
};
const serializeEmail = (item) => {
    return typeof item.data.value === "string" ? item.data.value : "";
};
exports.serializeEmail = serializeEmail;
const validateEmail = (item) => {
    const isValidEmail = validateEmailString(item.data.value);
    if (item.required || item.data.value) {
        if (!isValidEmail) {
            return { valid: false, error: { message: "Must be a valid email." } };
        }
    }
    return { valid: true };
};
exports.validateEmail = validateEmail;
//# sourceMappingURL=email.js.map